export const ROUTES = {
  APPLICANT_DETAILS: '/opportunities/:opportunity.id/applicants',
  AURA: '/aura',
  DASHBOARD: '/dashboard',
  GIVE_RECCO: '/give-recco',
  HOME: '/',
  LOGIN: '/login',
  OPPORTUNITIES: '/opportunities',
  OPPORTUNITIES_CREATE: '/opportunities/create',
  OPPORTUNITIES_DETAIL: '/opportunities/:id',
  PUBLIC_PROFILE: '/profile/:accountId',
  SAVED_CANDIDATES: '/search-candidates/saved',
  SEARCH_CANDIDATES: '/search-candidates',
  SETTINGS: '/settings',
  SIGNUP: '/signup',
  VERIFY_EMAIL: '/verify-email',
} as const;

type PublicProfilePathOptions = {
  applicationId?: string;
  candidateId?: string;
  fromSearch?: boolean;
  opportunityId?: string;
  source?: 'applied' | 'recommended' | 'search';
  status?: string;
};

export const getPublicProfilePath = (accountId: string, options?: PublicProfilePathOptions): string => {
  let path = ROUTES.PUBLIC_PROFILE.replace(':accountId', accountId);
  const params = new URLSearchParams();

  if (options?.candidateId) {
    params.set('candidateId', options.candidateId);
  }

  if (options?.applicationId) {
    params.set('applicationId', options.applicationId);
  }

  if (options?.opportunityId) {
    params.set('opportunityId', options.opportunityId);
  }

  if (options?.source) {
    params.set('source', options.source);
  }

  if (options?.status) {
    params.set('status', options.status);
  }

  if (options?.fromSearch) {
    params.set('fromSearch', 'true');
  }

  const queryString = params.toString();
  if (queryString) {
    path = `${path}?${queryString}`;
  }

  return path;
};
